// Interactive stops map with inline AJAX edit side panel
import L from "leaflet";

// Fix Leaflet's default icon path issue
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

function initializeStopsMap() {
  const container = document.querySelector("[data-stops-map]");
  if (!container) return;

  const stopsUrl = container.getAttribute("data-stops-url");
  const editPathTemplate = container.getAttribute("data-edit-path");

  const panel = document.getElementById("stop-edit-panel");
  const panelBody = document.getElementById("panel-body");
  const panelName = document.getElementById("panel-stop-name");
  const closeBtn = document.getElementById("close-panel");

  if (!panel || !panelBody || !panelName || !closeBtn) return;

  const map = L.map(container).setView([48.7503, 30.2231], 14);

  L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
    attribution:
      '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    maxZoom: 19,
  }).addTo(map);

  function closePanel() {
    panel.style.display = "none";
    panelBody.innerHTML = "";
    map.invalidateSize();
  }

  function showPanelErrors(errors) {
    const existing = panelBody.querySelector(".panel-error-alert");
    if (existing) existing.remove();
    const alert = document.createElement("div");
    alert.className = "alert alert-danger panel-error-alert";
    alert.innerHTML =
      "<ul class='mb-0'>" +
      errors.map((e) => "<li>" + e + "</li>").join("") +
      "</ul>";
    panelBody.prepend(alert);
  }

  function attachFormHandler() {
    const form = panelBody.querySelector("form");
    if (!form) return;

    // Cancel button closes the panel instead of navigating
    const cancelBtn = form.querySelector("a.btn-outline-secondary");
    if (cancelBtn) {
      cancelBtn.addEventListener("click", function (e) {
        e.preventDefault();
        closePanel();
      });
    }

    form.addEventListener("submit", function (e) {
      e.preventDefault();

      const submitBtn = form.querySelector("[type=submit]");
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.innerHTML =
          '<span class="spinner-border spinner-border-sm me-1"></span>Збереження...';
      }

      const csrfToken = document
        .querySelector('meta[name="csrf-token"]')
        ?.getAttribute("content");

      fetch(form.action, {
        method: "POST", // FormData with _method=PATCH handles the override
        body: new FormData(form),
        headers: {
          "X-CSRF-Token": csrfToken,
          Accept: "application/json",
        },
      })
        .then(function (r) {
          return r.json().then(function (data) {
            return { ok: r.ok, data: data };
          });
        })
        .then(function ({ ok, data }) {
          if (ok && data.success) {
            closePanel();
          } else {
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.innerHTML = "Зберегти";
            }
            showPanelErrors(data.errors || ["Невідома помилка"]);
          }
        })
        .catch(function (err) {
          console.error("Failed to save stop:", err);
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.innerHTML = "Зберегти";
          }
          showPanelErrors(["Помилка з'єднання з сервером"]);
        });
    });
  }

  function openPanel(stopId, stopName) {
    const url = editPathTemplate.replace("__id__", stopId);
    panelName.textContent = stopName;
    panelBody.innerHTML =
      '<div class="d-flex justify-content-center align-items-center py-5">' +
      '<div class="spinner-border text-primary"></div>' +
      "</div>";
    panel.style.display = "flex";
    map.invalidateSize();

    fetch(url + "?panel=1", {
      headers: { "X-Requested-With": "XMLHttpRequest" },
    })
      .then(function (r) {
        if (!r.ok) throw new Error("HTTP " + r.status);
        return r.text();
      })
      .then(function (html) {
        panelBody.innerHTML = html;
        attachFormHandler();
      })
      .catch(function (err) {
        console.error("Failed to load form:", err);
        panelBody.innerHTML =
          '<div class="alert alert-danger m-3">Не вдалося завантажити форму</div>';
      });
  }

  closeBtn.addEventListener("click", closePanel);

  fetch(stopsUrl)
    .then(function (r) {
      return r.json();
    })
    .then(function (stops) {
      stops.forEach(function (stop) {
        if (!stop.lat || !stop.lng) return;
        const marker = L.marker([stop.lat, stop.lng]);
        const popup = L.popup({ maxWidth: 240 }).setContent(
          "<div>" +
            '<strong style="font-size:0.9rem">' +
            stop.name +
            "</strong>" +
            "<br>" +
            '<button class="stop-popup-btn" data-stop-id="' +
            stop.id +
            '" data-stop-name="' +
            stop.name.replace(/"/g, "&quot;") +
            '">' +
            '<i class="bi bi-pencil me-1"></i>Редагувати' +
            "</button>" +
            "</div>",
        );
        marker.bindPopup(popup);
        marker.addTo(map);
      });

      container.addEventListener("click", function (e) {
        const btn = e.target.closest("[data-stop-id]");
        if (btn) {
          openPanel(btn.dataset.stopId, btn.dataset.stopName);
        }
      });
    })
    .catch(function (err) {
      console.error("Failed to load stops:", err);
    });
}

document.addEventListener("turbo:load", initializeStopsMap);
document.addEventListener("turbolinks:load", initializeStopsMap);
document.addEventListener("DOMContentLoaded", initializeStopsMap);
